const TIMESTAMP_FORMATTER = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true })

export const formatRunTimestamp = (epochSeconds: number | null): string => (epochSeconds ? TIMESTAMP_FORMATTER.format(new Date(epochSeconds * 1000)) : '—')
